import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ManagementApiService } from "services/apiServices";

const initialState = {
    data: { loading: false, cbmList: [], error: "" },
};

export const fetchAllCbmList = createAsyncThunk(
    "allcbm/fetchAllCbmList",
    async (params) => {
        const request = await ManagementApiService.GetAllCbmList(params);
        const respond = await request.data;
        return respond;
    },
 
);
// export const fetchAllCbmListType = createAsyncThunk(
//     "allcbm/fetchAllCbmList",
//     async (id) => {
//         const request = await ManagementApiService.GetAllcbmType(id);
//         const respond = await request.data;
//         return respond;
//     },

// );

const cbmSlice = createSlice({
    name: "allcbm",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAllCbmList.pending, (state) => {
            state.data = {
                loading: true,
                cbmList: [],
                error: "",
            };
        });
        builder.addCase(fetchAllCbmList.fulfilled, (state, actions) => {
            state.data = {
                loading: false,
                cbmList: actions.payload,
                error: "",
            };
        });
        builder.addCase(fetchAllCbmList.rejected, (state, actions) => {
            state.data = {
                loading: false,
                cbmList: [],
                error: actions.error.message,
            };
        });
    },
});

export default cbmSlice.reducer;
